module.exports = require("@ember/debug/data-adapter");